module.exports = __webpack_public_path__ + "static/media/tabs-icon-draw-objects.cd00ca64.svg";